<template>
  <right-panel :datas="connects" ref="rightPanel" @onClose="onClose" :hideFooter="true">
    <div slot="header" v-if="connects">
      {{connects.assistType === 'Manual' ? attrText.manualAssist : attrText.operationAssist}}
    </div>
    <div slot="content" class="loading" v-if="initLoading">
      <img src="../../../assets/loading.gif"/>
    </div>
    <div slot="content" class="assist-content" v-if="!initLoading">
      <translate class="tip-name" tag="p">Connection Info</translate>
      <div class="connect-detail">
        <el-row>
          <el-col :span="6" class="detail-tip">
            <translate>Host</translate>
            :
          </el-col>
          <el-col :span="14">{{connectionInfo.host}}</el-col>
          <el-col :span="4" class="copy" v-clipboard:copy="connectionInfo.host" v-clipboard:success="copySuccess"><a
            href="javascript:;">
            <translate>Copy</translate>
          </a></el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="detail-tip">
            <translate>Port</translate>
            :
          </el-col>
          <el-col :span="14">{{connectionInfo.port}}</el-col>
          <el-col :span="4" class="copy" v-clipboard:copy="connectionInfo.port" v-clipboard:success="copySuccess"><a
            href="javascript:;">
            <translate>Copy</translate>
          </a></el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="detail-tip">
            <translate>Username</translate>
            :
          </el-col>
          <el-col :span="14">{{connectionInfo.username}}</el-col>
          <el-col :span="4" class="copy" v-clipboard:copy="connectionInfo.username" v-clipboard:success="copySuccess"><a
            href="javascript:;">
            <translate>Copy</translate>
          </a></el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="detail-tip">
            <translate>SSH command</translate>
            :
          </el-col>
          <el-col :span="14"><a :href="sshLink">{{sshCommand}}</a></el-col>
          <el-col :span="4" class="copy" v-clipboard:copy="sshCommand" v-clipboard:success="copySuccess"><a>
            <translate>Copy</translate>
          </a></el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="detail-tip detail-usename">
            <translate>Connect Username</translate>
            :
          </el-col>
          <el-col :span="14">
            <el-input class="user-input" v-model="connectionInfo.defaultName"></el-input>
          </el-col>
          <el-col :span="4" class="copy"><a href="javascript:;">
            <el-button type="primary" class="connect-btn" @click.stop="connectHost()">
              <translate>Connect</translate>
            </el-button>
          </a></el-col>
        </el-row>
      </div>
      <p class="tip-name">
        <translate>Assistance Info</translate>
      </p>

      <div class="get-assist-info" v-if="connects && connects.assistType === 'Manual'">
        <translate v-if="!assistInfo" tag="h5" class="connect-host">
          Please connect to the host for assistance information
        </translate>
        <div style="height: 300px" v-loading="loading" v-if="loading"></div>
        <el-button v-if="!loading && !assistInfo" class="re-get" @click.stop="getAssistInfo(connectionInfo.code)"
                   type="primary">
          <translate>Get Again</translate>
        </el-button>
        <div v-if="assistInfo">
          <div class="assist-detail">
            <translate tag="p">Temporary assistance link are created successfully and can be sent to assistants!
            </translate>
            <p>
              <translate>Assistance address</translate>
              : {{assistLink}} <a href="javascript:;" class="copy" v-clipboard:copy="assistLink"
                                  v-clipboard:success="copySuccess">
              <translate>Copy</translate>
            </a></p>
            <translate tag="p" class="tip-msg">
              (Valid time:30 minutes or the main connection is disconnected)
            </translate>
            <!--<translate tag="p">Or using the operation and maintenance assistant to assist</translate>-->
          </div>
        </div>
      </div>
      <div class="get-assist-info" v-if="connects && connects.assistType === 'Operation'">
        <translate tag="h5" class="connect-host">Please connect to the host for assistance information</translate>
        <el-button v-if="!loading && !assistInfo" class="re-get" @click.stop="getAssistInfo(connectionInfo.code)"
                   type="primary">
          <translate>Get Again</translate>
        </el-button>
        <div v-if="loading && !assistInfo || assistInfo">
          <div class="assist-ewm">
            <div class="img-cover" v-if="loading">
              <img class="img-cover-bg" src="../../../assets/ewm.png" width="168" height="168"/>
              <div class="loading-bg">
                <div class="loadEffect">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
            </div>
            <qr-code
              v-if="assistInfo"
              :text="assistInfo.url"
              :size="150"
              color="#000"
              bg-color="#fff"
              error-level="L"
              title="333"
              class="ewm-img">
            </qr-code>
            <translate tag="p">Use the operation and maintenance assistant to scan the above two-dimensional code
            </translate>
            <translate tag="p" style="margin-top: 40px">Please download </translate>
            <img src="../../../assets/appstore.png" alt="app 下载" class="app-store">
          </div>
        </div>
      </div>
    </div>
  </right-panel>
</template>

<script>
  import RightPanel from '../../common/right-panel'
  import STORE_CONST from '../../../store/consts'
  import { baseUrl } from '../../../config'
  import Utility from '../../../Utils'
  import Base64 from 'js-base64'
  export default{
    name: 'WorkGroupAssist',
    props: {
      items: {
        required: true
      }
    },
    data () {
      return {
        connects: null,
        loading: true,
        isLoad: false,
        firstConnectInfo: {
          userName: '',
          code: '',
          agentVersion: ''
        },
        connectionInfo: {
          path: '/wetty/ssh',
          code: '',
          host: '',
          port: '',
          username: '',
          defaultName: 'root',
          linkUser: ''
        },
        shadowConnect: {
          agent_host: '',
          agent_webtty_port: '',
          code: ''
        },
        time: 0,
        assistInfo: null,
        initLoading: true
      }
    },
    created () {
    },
    computed: {
      attrText () {
        return this.initAttrText()
      },
      sshCommand () {
        return 'ssh' + ' ' + this.connectionInfo.code + '_' + this.connectionInfo.defaultName + '@' + this.connectionInfo.host + ' -p ' + this.connectionInfo.port
      },
      sshLink () {
        if (window.navigator.userAgent.indexOf('Macintosh') > -1) {
          return 'ssh://' + this.connectionInfo.code + '_' + this.connectionInfo.defaultName + '@' + this.connectionInfo.host + ':' + this.connectionInfo.port
        } else {
          return 'ssh2://' + this.connectionInfo.code + '_' + this.connectionInfo.defaultName + '@' + this.connectionInfo.host + ':' + this.connectionInfo.port
        }
      },
      assistLink () {
        let agentVersionFirst = parseInt(this.firstConnectInfo.agentVersion.split('.')[0])
        console.log('agentVersionFirst', agentVersionFirst)
        // 2.0.0 版本起改为Query Params
        if (!isNaN(agentVersionFirst) && agentVersionFirst > 1) {
          if (agentVersionFirst >= 3) {
            return 'http://' + this.shadowConnect.agent_host + ':' + this.shadowConnect.agent_webtty_port + '/?code=' + Base64.Base64.encode(this.shadowConnect.code) + '&user=' + this.connectionInfo.defaultName
          } else {
            return 'http://' + this.shadowConnect.agent_host + ':' + this.shadowConnect.agent_webtty_port + '/?code=' + this.shadowConnect.code + '&user=' + this.connectionInfo.defaultName
          }
        } else {
          return 'http://' + this.shadowConnect.agent_host + ':' + this.shadowConnect.agent_webtty_port + this.connectionInfo.path + '/' + this.shadowConnect.code + '/' + this.connectionInfo.defaultName
        }
      }
    },
    methods: {
      initAttrText () {
        return {
          manualAssist: this.$gettext('Manual assistance'),
          operationAssist: this.$gettext('Operation assistant')
        }
      },
      // copy text success
      copySuccess (e) {
        this.$notify({
          message: this.$gettext('Copy successfully!'),
          type: 'success'
        })
      },
      getShadowConnect (key, version) {
        let params = {
          master_connection_id: key,
          readonly: false,
          expire_time: Math.floor(new Date().getTime() / 1000) + 30 * 60
        }
        if (version && version >= '3.0.0') {
          this.$store.dispatch(STORE_CONST.WORKGROUP.GET_CSOS_SHADOW, params).then(res => {
            this.shadowConnect.agent_host = res.agent_host
            this.shadowConnect.agent_webtty_port = res.agent_webtty_port
            this.shadowConnect.code = res.code
            this.loading = false
            this.assistInfo = {
              url: `${baseUrl.h5Url}#/assistant/list?from=cloudcare&id=${key}&fromCsos=true&bgColor=white&code=${Base64.Base64.encode(res.code)}&agent_host=${res.agent_host}&agent_port=${res.agent_webtty_port}`
            }
          })
        } else {
          this.$store.dispatch(STORE_CONST.WORKGROUP.GET_SHADOW_CONNECT, params).then(res => {
            this.shadowConnect.agent_host = res.agent_host
            this.shadowConnect.agent_webtty_port = res.agent_webtty_port
            this.shadowConnect.code = res.code
            this.loading = false
            this.assistInfo = {
              url: `${baseUrl.h5Url}#/assistant/list?from=cloudcare&id=${key}&fromCsos=true&bgColor=white&code=${Base64.Base64.encode(res.code)}&agent_host=${res.agent_host}&agent_port=${res.agent_webtty_port}`
            }
          })
        }
      },
      // 获取协助信息
      getAssistInfo (newCode, version) {
        this.loading = true
        this.time++
        let params = {
          code: newCode
        }
        if (version && version >= '3.0.0') {
          this.$store.dispatch(STORE_CONST.WORKGROUP.QUERY_CSOS_CONNECT, params).then(res => {
            if (res.connections.length < 1) {
              if (this.time < 60) {
                setTimeout(() => {
                  this.getAssistInfo(newCode, version)
                }, 1000)
              } else {
                this.time = 0
                this.loading = false
              }
            } else {
              this.time = 0
              let connectObj = res.connections[0]
              // 该判断代表是人工协助
//              if (this.connects.assistType === 'Manual') {
              this.getShadowConnect(connectObj.connection_id, version)
//              }
            }
          })
        } else {
          this.$store.dispatch(STORE_CONST.WORKGROUP.GET_ASSIST_INFO, params).then(res => {
            if (Object.isEmpty(res)) {
              if (this.time < 60) {
                setTimeout(() => {
                  this.getAssistInfo(newCode)
                }, 1000)
              } else {
                this.time = 0
                this.loading = false
              }
            } else {
              this.time = 0
              this.loading = false
              let keys = []
              for (let key in res) {
                keys.push(key)
              }
              this.getShadowConnect(keys[0])
            }
          })
        }
      },
      getConnectLog (id, version) {
        let agentVersion = Utility.Utils.getAgentVersion(version)
        this.firstConnectInfo.agentVersion = agentVersion
        console.log('agentVersion', agentVersion)
        if (agentVersion >= '3.0.0') {
          // 新版本请求csos agent
          let params = {
            project_resource_id: id,
            tmpAssist: true
          }
          this.$store.dispatch(STORE_CONST.WORKGROUP.GET_TUNNEL_INFO, params).then((res) => {
            this.initLoading = false
            this.firstConnectInfo.code = res.code
            this.getAssistInfo(this.firstConnectInfo.code, agentVersion)
            if (!this.isLoad) {
              let usernameList = JSON.parse(res.resource.extension).username
              if (res.project_resource.default_username) {
                this.firstConnectInfo.username = res.project_resource.default_username
              } else {
                this.firstConnectInfo.username = usernameList[0]
              }
              this.connectionInfo = Object.assign(this.connectionInfo, {
                code: res.code,
                host: res.agent.host,
                port: res.agent.ssh_port,
                defaultName: this.firstConnectInfo.username,
                webPort: res.agent.web_port,
                username: res.code + '_' + this.firstConnectInfo.username
              })
              this.isLoad = true
              this.assistLink = ''
            }
          }, () => {
            this.initLoading = false
          })
        } else {
          let params = {
            project_resource_id: id
          }
          // 请求csos tunnel判断版本信息and拿默认用户名
          this.$store.dispatch(STORE_CONST.WORKGROUP.GET_TUNNEL_INFO, params).then((res) => {
            this.firstConnectInfo.agentVersion = res.agent.version
            this.firstConnectInfo.code = res.code
            let usernameList = JSON.parse(res.resource.extension).username
            if (res.project_resource.default_username) {
              this.firstConnectInfo.username = res.project_resource.default_username
            } else {
              this.firstConnectInfo.username = usernameList[0]
            }
            // 旧版本请求lite接口
            let params = {
              host: res.agent.host,
              ssh_port: res.agent.ssh_port,
              user: res.code + '_' + this.firstConnectInfo.username
            }
            this.$store.dispatch(STORE_CONST.WORKGROUP.GET_LITE_CONNECT_INFO, params).then(connect => {
              this.getAssistInfo(connect.code)
              if (!this.isLoad) {
                this.connectionInfo = Object.assign(this.connectionInfo, {
                  code: connect.code,
                  host: connect.agent_host,
                  port: connect.agent_ssh_port,
                  defaultName: connect.user,
                  webPort: connect.agent_webtty_port,
                  username: connect.code + '_' + connect.user
                })
                this.isLoad = true
              }
            })
          })
        }
      },
      connectHost () {
        let _link = 'http://' + this.connectionInfo.host + ':' + this.connectionInfo.webPort + this.connectionInfo.path + '/' + this.connectionInfo.code + '/' + this.connectionInfo.defaultName
        let agentVersionFirst = parseInt(this.firstConnectInfo.agentVersion.split('.')[0])

        // 2.0.0 版本起改为Query Params
        if (!isNaN(agentVersionFirst) && agentVersionFirst > 1) {
          if (agentVersionFirst >= 3) {
            _link = 'http://' + this.connectionInfo.host + ':' + this.connectionInfo.webPort + '/?code=' + Base64.Base64.encode(this.connectionInfo.code) + '&user=' + this.connectionInfo.defaultName
          } else {
            _link = 'http://' + this.connectionInfo.host + ':' + this.connectionInfo.webPort + '/?code=' + this.connectionInfo.code + '&user=' + this.connectionInfo.defaultName
          }
        }
        window.open(_link)
      },
      onClose () {
        this.$emit('onClosePanel')
        this.connects = null
        this.time = 60
      }
    },
    watch: {
      'items': {
        handler: function (newVal) {
          if (this.connects) {
            this.connects = null
            setTimeout(() => {
              this.connects = this.items
              this.getConnectLog(this.connects.projectResourceId, this.connects.agentVersion)
            }, 300)
          } else {
            this.connects = this.items
            this.getConnectLog(this.connects.projectResourceId, this.connects.agentVersion)
          }
        },
        deep: true
      }
    },
    components: {
      RightPanel
    }
  }
</script>

<style lang='scss' rel="stylesheet/scss">
  @import "../../../assets/css/variable";
  .loading{
    width:100%;
    height: 500px;
    position: relative;
    img{
      display: block;
      position: absolute;
      left:50%;
      top:50%;
      margin-left:-34px;
      margin-top:-34px;
    }
  }
  .assist-content {
    .tip-name {
      padding-left: 20px;
      line-height: 30px;
      border-top: 1px solid $border-color;
      border-bottom: 1px solid $border-color;
    }
    .connect-detail {
      padding: 20px 0;
      .el-row {
        margin-bottom: 10px;
      }
      .detail-tip {
        padding-right: 20px;
        text-align: right;
        &.detail-usename {
          line-height: 32px;
        }
      }
      .copy {
        padding-left: 8px;
        .connect-btn {
          padding: 8px 10px;
        }
      }
    }
    .get-assist-info {
      text-align: center;
      .re-get {
        margin-top: 50px;
      }
      .connect-host {
        margin-top: 30px;
      }
      .assist-detail {
        text-align: left;
        padding: 0 6%;
        margin-top: 30px;
        p {
          margin-bottom: 10px;
          .copy {
            margin-left: 10px;
          }
        }
        .tip-msg {
          color: #B8B8B8;
        }
      }
      .assist-ewm {
        margin-top: 30px;
        text-align: center;
        padding: 0 6%;
        .img-cover {
          position: relative;
          height: 168px;
          overflow: hidden;
          .img-cover-bg {
            position: absolute;
            left: 50%;
            margin-left: -84px;
          }
          .loading-bg {
            z-index: 10;
            width: 168px;
            height: 168px;
            background: rgba(255, 255, 255, 0.8);
            position: absolute;
            left: 50%;
            margin-left: -84px;
            .loadEffect {
              width: 100px;
              height: 100px;
              position: absolute;
              left: 50%;
              top: 50%;
              margin-top: -50px;
              margin-left: -50px;
              span {
                display: inline-block;
                width: 16px;
                height: 16px;
                border-radius: 50%;
                background: #4085FF;
                position: absolute;
                animation: load 1.04s ease infinite;
                -webkit-animation: load 1.04s ease infinite;
                &:nth-child(1) {
                  left: 0;
                  top: 50%;
                  margin-top: -8px;
                  animation-delay: 0.13s;
                  -webkit-animation-delay: 0.13s;
                }
                &:nth-child(2) {
                  left: 14px;
                  top: 14px;
                  animation-delay: 0.26s;
                  -webkit-animation-delay: 0.26s;
                }
                &:nth-child(3) {
                  left: 50%;
                  top: 0;
                  margin-left: -8px;
                  animation-delay: 0.39s;
                  -webkit-animation-delay: 0.39s;
                }
                &:nth-child(4) {
                  top: 14px;
                  right: 14px;
                  animation-delay: 0.52s;
                  -webkit-animation-delay: 0.52s;
                }
                &:nth-child(5) {
                  right: 0;
                  top: 50%;
                  margin-top: -8px;
                  animation-delay: 0.65s;
                  -webkit-animation-delay: 0.65s;
                }
                &:nth-child(6) {
                  right: 14px;
                  bottom: 14px;
                  animation-delay: 0.78s;
                  -webkit-animation-delay: 0.78s;
                }
                &:nth-child(7) {
                  bottom: 0;
                  left: 50%;
                  margin-left: -8px;
                  animation-delay: 0.91s;
                  -webkit-animation-delay: 0.91s;
                }
                &:nth-child(8) {
                  bottom: 14px;
                  left: 14px;
                  animation-delay: 1.04s;
                  -webkit-animation-delay: 1.04s;
                }
              }
            }
          }
        }
        .loading {
          display: inline-block;
          width: 150px;
          height: 150px;
          background: url('../../../assets/ewm.png') no-repeat;
          background-size: 150px;
          .loading-img {
            display: inline-block;
            width: 120px;
            height: 120px;
            background: url('../../../assets/loading.gif') no-repeat;
            background-size: 120px;
          }
        }
        .ewm-img {
          display: inline-block;
          margin-bottom: 10px;
        }
        .app-store {
          margin-top: 10px;
          &:hover {
            cursor: pointer;
          }
        }
      }
    }

    @-webkit-keyframes load {
      0% {
        opacity: 1;
      }
      100% {
        opacity: 0.2;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// workgroup-assist.vue?699db5b8